module.exports = __webpack_public_path__ + "img/pptx.79d55db4.svg";